import { render, staticRenderFns } from "./LiberapayIcon.vue?vue&type=template&id=3ffa62eb&"
import script from "./LiberapayIcon.vue?vue&type=script&lang=js&"
export * from "./LiberapayIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports